import React, { useContext, useState } from 'react';
import './TodoForm.css';
import { TodoContext } from '../../TodoContext';

export function TodoForm() {
  const { setOpenModal, addTodo } = useContext(TodoContext);
  const [newTodoValue, setNewTodoValue] = useState('');

  const onSubmit = (ev) => {
    ev.preventDefault();
    addTodo(newTodoValue);
    setOpenModal(false);
  }

  const onCancel = (ev) => {
    setOpenModal(false);
  };

  const onChange = (ev) => {
    setNewTodoValue(ev.target.value);
  };
  return (
    <form onSubmit={onSubmit}>
      <div className='Field-Container'>
        <label>Write your To-Do:</label>
        <textarea
          value={newTodoValue}
          onChange={onChange}
          placeholder='Feed my dolphins'
        />
      </div>
      <div className='Buttons-Container'>
        <button type="button" onClick={onCancel} className='TodoForm__Cancel'>
          Cancel
        </button>
        <button className='TodoForm__Add'>
          Add
        </button>
      </div>
    </form>
  )
}